// Client-side branch scope helpers (mirror of backend utils/branch_scope.py).
// Backend enforces data isolation; these only keep filter dropdowns tidy.
export const getUserBranchScope = () => {
  try {
    const u = JSON.parse(localStorage.getItem('prismoline_user') || '{}');
    return Array.isArray(u.allowed_branches) && u.allowed_branches.length ? u.allowed_branches : null;
  } catch {
    return null;
  }
};

export const filterBranchesForUser = (branches) => {
  const scope = getUserBranchScope();
  if (!scope) return branches || [];
  return (branches || []).filter(b => scope.includes(b.id));
};
